import { Commit } from "vuex";
import { http } from "../../plugins/axios";

export interface MaternityExtState {}

const state = (): MaternityExtState => ({});

const mutations = {};

const getters = {};

const actions = {
  async createMaternityExtApplication(
    { commit }: { commit: Commit },
    data: any
  ) {
    const endpoint = "/application/maternity/extend";

    const res = await http.post(endpoint, data);

    return res.data;
  },
  async getMaternityExtTypes() {
    const endpoint = "/application/Maternity_Extension/types";

    const res = await http.get(endpoint);

    return res.data;
  },
  async getEligibleBenefits() {
    const endpoint = "/application/maternity/claims";

    const res = await http.get(endpoint);

    return res.data;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
